export default "__VITE_ASSET__B3VVDKXQ__"